export const TIP_MSG_MAP = {
  autoLineCreateSuccess: '新增成功！',
  autoLineCreateError: '新增失败！',
  updateRecordSuccess: '更新成功！',
  updateRecordError: '更新失败！',
  getRecordError: '获取记录失败！',
  getFileError: '获取文件失败!',
};
